export enum StudentLoanEligibilityResult {
  Eligible = 'eligible',
  NotEligible = 'notEligible',
  Error = 'error',
  SessionExpired = 'sessionExpired',
}

export enum StudentLoanEmployerResult {
  NonProfit = 'nonProfit',
  ForProfit = 'forProfit',
  NotSure = 'notSure',
}

export enum StudentLoanNotEnrolledResult {
  Applying = 'applying',
  WontApprove = 'wontApprove',
  DifficultToApply = 'difficultToApply',
  WontSaveMoney = 'wontSaveMoney',
}

export enum StudentLoanPslfWontSaveMoneyResult {
  IsStudent = 'IsStudent',
  Other = 'Other',
}

export enum StudentLoanSavingsResult {
  Next = 'next',
  NotNow = 'notNow',
  ApplyOptions = 'applyOptions',
}

export enum StudentLoanApplyOnYourOwnResult {
  Done = 'done',
}

export enum ComeBackWhenDueResult {
  SeeEnrollmentSteps = 'seeEnrollmentSteps',
}

export enum PaymentSituationResult {
  Yes = 'Yes',
  ImAStudent = 'imAStudent',
  Other = 'other',
}

export enum UploadLoanInformationResult {
  EstimateChanged = 'EstimateChanged',
  YourSavings = 'YourSavings',
  NoChange = 'NoChange',
  NotNow = 'NotNow',
  NoSavings = 'NoSavings',
}

export type StudentLoanForgivenessResults =
  | StudentLoanEligibilityResult
  | StudentLoanEmployerResult
  | StudentLoanNotEnrolledResult
  | StudentLoanPslfWontSaveMoneyResult
  | StudentLoanSavingsResult
  | StudentLoanApplyOnYourOwnResult
  | ComeBackWhenDueResult
  | PaymentSituationResult
  | UploadLoanInformationResult;
